import {Button} from '@primer/react'
import {useFeedbackDialog as useGenericFeedbackDialog} from './useFeedbackDialog'
import {useCallback, useRef} from 'react'
import {type RatingOption, frustratedIcon, frownIcon, smileIcon, grinIcon} from '@github-ui/user-feedback'
import {useCurrentUserOptional} from '../../../contexts/CurrentUserContext'

const ratingOptions: Array<RatingOption<'VERY_NEGATIVE' | 'NEGATIVE' | 'POSITIVE' | 'VERY_POSITIVE'>> = [
  {
    name: 'Hate it',
    value: 'VERY_NEGATIVE' as const,
    icon: frustratedIcon,
    color: 'veryDissatisfied',
  },
  {
    name: 'Not great',
    value: 'NEGATIVE' as const,
    icon: frownIcon,
    color: 'dissatisfied',
  },
  {
    name: 'It’s ok',
    value: 'POSITIVE' as const,
    icon: smileIcon,
    color: 'satisfied',
  },
  {
    name: 'Love it',
    value: 'VERY_POSITIVE' as const,
    icon: grinIcon,
    color: 'verySatisfied',
  },
]

export const useFeedbackDialog = (sessionId?: string, currentUserLogin?: string) => {
  // include the session ID in the feedback dialog title if provided
  const dialogKey = sessionId ? `task-header:session_id=${sessionId}` : `task-header`
  return useGenericFeedbackDialog(dialogKey, ratingOptions, currentUserLogin)
}

export function FeedbackButton({sessionId}: {sessionId?: string}) {
  const currentUserLogin = useCurrentUserOptional()?.currentUser?.login
  const {openFeedback, FeedbackDialog} = useFeedbackDialog(sessionId, currentUserLogin)
  const buttonRef = useRef<HTMLButtonElement>(null)
  const onClick = useCallback(() => openFeedback(), [openFeedback])

  return (
    <>
      <Button ref={buttonRef} variant="link" className="f6" onClick={onClick}>
        Give feedback
      </Button>
      <FeedbackDialog returnFocusRef={buttonRef} />
    </>
  )
}
